module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou4-a295374d0367fcc950b3ea403ae02304.jpg";